import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SSO_REQUEST_TOKEN_CODE: {
  SSO_REQUEST_TOKEN_CREATE_INVALID: MvnCodeBE;
  SSO_REQUEST_TOKEN_VERIFY_INVALID: MvnCodeBE;
  SSO_REQUEST_TOKEN_NOT_FOUND: MvnCodeBE;
} = {
  SSO_REQUEST_TOKEN_CREATE_INVALID: {
    status: 400,
    ko: "이메일 혹은 비밀번호를 잘못 입력하셨습니다.",
    en: "The email address or password you entered is invalid.",
  },
  SSO_REQUEST_TOKEN_VERIFY_INVALID: {
    status: 400,
    ko: "유효하지 않은 토큰입니다.",
    en: "The specified credential is not valid.",
  },
  SSO_REQUEST_TOKEN_NOT_FOUND: {
    status: 404,
    ko: "Request Token({id}) 정보를 찾을 수 없습니다.",
    en: "Request Token({id}) could not be found.",
  },
};

MvnCodeInitiate(SSO_REQUEST_TOKEN_CODE);
